var map = {
	"./AdjustableAir.webp": 2583,
	"./InnerspringMattresses.webp": 5758,
	"./MemoryFoam.webp": 936,
	"./PillowTop.webp": 2154,
	"./loganacorn.webp": 1184,
	"./porschiataupe.webp": 8954,
	"./telluridecafe.webp": 1323,
	"./wypsywriftwood.webp": 909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1175;